export default __webpack_public_path__ + "static/media/phone.ecec7db5.svg";